import { addFaqs, fetchFaqs, editFaqs, deleteFaqs, destroyFaqs } from "../actions/faqs_action";
import { fetchFaqsMeta, editFaqsMeta } from "../actions/faqs_meta_action";
import Helping from "../helpers/Helping";
import Service from "../helpers/service";
import { GET_FAQS } from '../config/routes';
import { API_URL } from '../config/urls';
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {

}


export const setFaqError = (callback) => {

    updateCallback = callback;

}

export const getAll = (page, limit, sorting, type, sort_type, search) => {
    return dispatch => {
        let body = {
            "action": "list",
            "page": page,
            "limit": limit,
            "type": type,
            "search": search,
            "sorting": sorting,
            "sort_type": sort_type
        };
        return trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + GET_FAQS, body)
                .then(response => {
                    let { faqs } = response.data.payload;
                    let total = faqs.total;
                    dispatch(fetchFaqs(faqs.rows));
                    return dispatch(fetchFaqsMeta({
                        page: page,
                        limit: limit,
                        sorting: sorting,
                        sort_type: sort_type,
                        search: search,
                        total: total,
                        no_Of_pages: Math.ceil(total / limit)
                    }));
                }).catch(error => {
                    dispatch(fetchFaqs([]));
                    dispatch(fetchFaqsMeta({
                        page: page,
                        limit: limit,
                        sorting: sorting,
                        sort_type: sort_type,
                        search: search,
                        total: 0,
                        no_Of_pages: page
                    }));
                    Helping.redirectToLogin(error);
                    console.log('error while fetching faqs: ', error);
                    return updateCallback({
                        ...Helping.setNetworkRequestError(error, "fetching faqs")
                    })
                })
        )
    };
};

export const create = (data) => {
    return dispatch => {
        dispatch(addFaqs(data));
    };
};

export const update = (data) => {
    return dispatch => {
        dispatch(editFaqs(data));
    };
};

export const updateFaqsMeta = (payload) => {
    return dispatch => {
        dispatch(editFaqsMeta(payload));
    };
};

export const removeFaqs = (id) => {
    return dispatch => {
        dispatch(deleteFaqs(id));
    };
};

export const destroy = key => {
    return dispatch => dispatch(destroyFaqs(key));
}